import React, { useContext, useEffect, useState } from 'react'
import { Form, Input, Modal, Tooltip } from 'antd'
import { TableContext } from '../../'
import { ExclamationCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import SkuInfo from './components/skuInfo'
import UploadImg from './components/uploadImg'
import { Data, getRules, restrictCNLength } from '../../utils'
import { Status, statusMaps, GetStatusBtn } from './type'
import './index.less'
//import { IS_PROD } from '@zero/mc-utils'
import { isEmpty } from 'lodash'

interface Params extends Data {
  width?: string | number
  render?: (rules: any, record: any) => JSX.Element
}

const spicialCodeList = [
  'skuMaterialStatus',
  'opt',
  'smartContentSell',
  'smartContentSortTitle',
  'picUrl',
  'smartPicWhite',
] // 特殊处理

const renderTitle = (item: Params): JSX.Element => {
  const titleContainer = (text: string | JSX.Element, isShow = true) => (
    <div className="pool-title">
      <div>
        <span
          className="pool-required"
          style={{ visibility: JSON.parse(getRules('required', item)) ? 'inherit' : 'hidden' }}
        >
          *
        </span>
        {item.nameJsx || item.name}
        {item.titleExtra}
      </div>
      {isShow ? (
        <div className="pool-info">
          填写要求
          <Tooltip placement="top" title={text}>
            <ExclamationCircleOutlined style={{ marginLeft: 2 }} />
          </Tooltip>
        </div>
      ) : (
        ''
      )}
    </div>
  )
  const titleMaps = {
    '1': () =>
      titleContainer(
        <React.Fragment>
          {item.titleInfo ? (
            <div>{item.titleInfo}</div>
          ) : (
            <div>
              内容要求最少{getRules('minLength', item)}个汉字，最多{getRules('maxLength', item)}个汉字。
            </div>
          )}
        </React.Fragment>
      ),
    '2': () =>
      titleContainer(
        <div className="form-img-rules">
          <React.Fragment>
            {item.titleInfo ? (
              <div>{item.titleInfo}</div>
            ) : (
              <div>
                宽高{getRules('imgWidth', item)}*{getRules('imgHeight', item)}，
                {getRules('imgSize', item) ? `大小${getRules('imgSize', item)}kb以内；` : ''}格式为
                {getRules('imgExtension', item)}。
              </div>
            )}
          </React.Fragment>
        </div>
      ),
  }
  const fuc = titleMaps[item.dataType + '']
  return fuc ? fuc() : titleContainer('', false)
}

const HandleCutout = ({ form, record, rowIndex, isProd }) => {
  const [showCutout, setShowCutout] = useState(false)
  const [lingLongUrl, setLingLongUrl] = useState('')
  const [imgUrl, setImgUrl] = useState(null)

  const afterClose = () => {
    if (Array.isArray(imgUrl) && (imgUrl as []).length > 1) {
      if (
        record.editorStatus &&
        !(
          Status['审核失败'] === record.skuMaterialStatus &&
          record['smartPicTransparent'] &&
          record['smartPicTransparent'].status &&
          record['smartPicTransparent'].status !== 5
        )
      ) {
        form.setFieldsValue({ [`${rowIndex}-smartPicTransparent`]: imgUrl[0] })
      }
      if (
        record.editorStatus &&
        !(
          Status['审核失败'] === record.skuMaterialStatus &&
          record['smartPicWhite'] &&
          record['smartPicWhite'].status &&
          record['smartPicWhite'].status !== 5
        )
      ) {
        form.setFieldsValue({ [`${rowIndex}-smartPicWhite`]: imgUrl[1] })
      }
    }
  }

  const onCancel = () => {
    setImgUrl(null)
    setShowCutout(false)
  }

  useEffect(() => {
    window.addEventListener('message', (e) => {
      if (e.data && e.data.action === 'ling:cutoutImageUrl' && e.data.data.cancel) {
        onCancel()
      }
      if (
        e.data &&
        e.data.action === 'ling:cutoutImageUrl' &&
        Array.isArray(e.data.data.img) &&
        !isEmpty(e.data.data.img)
      ) {
        setImgUrl(e.data.data.img)
        setShowCutout(false)
      }
    })
  }, [])

  const getlingLongUrl = () => {
    const lingLongHost = isProd ? '//ling.jd.com' : '//ling-test.jd.com'
    setShowCutout(true)
    setLingLongUrl(
      `${lingLongHost}/v2/embed/cutout?image=${record.skuImg}&background=transparent,white&contentProportion=85&sizeType=rect&width=800&height=800&manual=rectSize,contentProportion&isProportion=true`
    )
  }
  return (
    <>
      <a
        style={{ marginLeft: '4px' }}
        onClick={getlingLongUrl}
        clstag="pageclick|keycount|linglong_manual_1691377361350|1"
      >
        手动调整
      </a>
      <Modal
        destroyOnClose
        visible={showCutout}
        title={
          <div slot="header" className="ling-long-header">
            <a href="https://ling.jd.com/" className="ling-long-jump" target="_blank" rel="noopener noreferrer"></a>
          </div>
        }
        onCancel={onCancel}
        width={'100vw'}
        wrapClassName="linglong-cutout"
        footer={null}
        afterClose={afterClose}
      >
        <div style={{ height: 'calc(100vh - 103px)' }}>
          <iframe style={{ width: '100%', height: '100%', border: 0 }} src={lingLongUrl}></iframe>
        </div>
      </Modal>
    </>
  )
}

const getExtNode = ({ updateConfig, record, name, rowIndex, form, isProd }) => {
  let extraNode = null
  let flag = false
  if (
    updateConfig.current.status ||
    updateConfig.current.skuId === record.skuId ||
    (updateConfig.current.skuId && (updateConfig.current.skuId + '').indexOf(record.skuId) !== -1)
  ) {
    if (record[name] && record[name].value) {
      // 审核失败
      const fail = record[name] && record[name].failReason ? true : false
      form.setFields([
        {
          errors: fail
            ? [
                // eslint-disable-next-line react/jsx-key
                <>
                  <Tooltip placement="topLeft" title={record[name].failReason}>
                    <div>
                      <ExclamationCircleFilled />
                      &nbsp;查看失败原因
                    </div>
                  </Tooltip>
                  {/* 图片类才展示手动调整入口 */}
                  {['smartPicTransparent', 'smartPicWhite'].includes(name) ? (
                    <HandleCutout form={form} record={record} rowIndex={rowIndex} isProd={isProd} />
                  ) : (
                    ''
                  )}
                </>,
              ]
            : [],
          name: [`${rowIndex}-${name}`],
          value: record[name].value,
        },
      ])
    } else {
      form.setFields([
        {
          errors: [],
          name: [`${rowIndex}-${name}`],
          value: '',
        },
      ])
    }
  }
  if (record[name] && record[name].flag) {
    extraNode = (
      <>
        <Tooltip
          placement="topLeft"
          title="系统自动抠图适用于图片结构及背景相对简单的场景，请检查系统抠图是否符合素材规范，若图片场景较复杂建议手动上传。"
          onVisibleChange={(open) => {
            if (open) {
              window.expLogJSON('z_1682315582492', '1')
            }
          }}
        >
          <div style={{ color: '#FEB00E', marginTop: 10 }}>
            <ExclamationCircleFilled style={{ marginRight: 4 }} />
            系统自动抠图，建议检查
          </div>
        </Tooltip>
        <HandleCutout form={form} record={record} rowIndex={rowIndex} isProd={isProd} />
      </>
    )
    flag = true
  }
  return { extraNode, flag }
}

const isCheckSpicialCode = (code: string): boolean => spicialCodeList.includes(code)

const BatchInput = ({ form, data, rowIndex, item, record, updateConfig, components: Components, isPic, isProd }) => {
  const { uploadImgUrl } = useContext(TableContext)
  // 初始化
  const { extraNode, flag } =
    isPic && getExtNode({ updateConfig, record, name: isPic ? item.id : item, rowIndex, form, isProd })
  const [isShowApplyBtn, setIsShowApplyBtn] = useState(false)
  const { id } = item || {}
  const applyValInSpu = (name) => {
    const currentVal = form.getFieldValue(`${rowIndex}-${name}`)
    const currentSpuId = record.spuId
    data.forEach((item, index) => {
      if (
        item.editorStatus &&
        !(
          Status['审核失败'] === item.skuMaterialStatus &&
          item[name] &&
          item[name].status &&
          item[name].status !== 5
        ) &&
        item.spuId === currentSpuId
      ) {
        form.setFieldsValue({ [`${index}-${name}`]: currentVal })
      }
    })
  }
  const applyToOther = () => {
    if (id === 'smartContentSortTitle') {
      applyValInSpu(id)
    } else if (id === 'smartContentSell') {
      applyValInSpu(id)
      applyValInSpu(`${id}2`)
      applyValInSpu(`${id}3`)
    } else if (id === 'smartPicTransparent') {
      applyValInSpu(id)
    } else if (id === 'smartPicWhite') {
      applyValInSpu(id)
    }
  }

  const onApplyBtnFocus = () => {
    setTimeout(() => {
      setIsShowApplyBtn(true)
    }, 500)
  }

  const onApplyBtnBlur = (e) => {
    setTimeout(() => {
      setIsShowApplyBtn(false)
    }, 300)
  }

  // 缓存组件状态
  const MemoizedComponent = React.useMemo(() => {
    return (
      <Components
        onApplyBtnBlur={onApplyBtnBlur}
        onApplyBtnFocus={onApplyBtnFocus}
        updateConfig={updateConfig}
        record={record}
        item={item}
        rowIndex={rowIndex}
        uploadImgUrl={uploadImgUrl}
        extraNode={extraNode}
        flag={flag}
        form={form}
      />
    )
  }, [form, data, rowIndex, item, record, updateConfig])

  return (
    <>
      {isPic ? (
        <span className="apply-input-btn" onClick={applyToOther}>
          应用至当页相同SPU
        </span>
      ) : (
        isShowApplyBtn && (
          <span className="apply-input-btn" onClick={applyToOther}>
            应用至当页相同SPU
          </span>
        )
      )}
      {MemoizedComponent}
    </>
  )
}
const SmartContentSell = ({ onApplyBtnBlur, onApplyBtnFocus, updateConfig, record, item, rowIndex, form, isProd }) => {
  const name = ['smartContentSell', 'smartContentSell2', 'smartContentSell3']
  name.forEach((item) => {
    getExtNode({ updateConfig, record, name: item, rowIndex, form, isProd })
  })
  const inputItem = (name, required) => {
    return (
      <Form.Item
        name={`${rowIndex}-${name}`}
        className="smart-input"
        validateTrigger="onBlur"
        style={{ marginBottom: 5 }}
        rules={[
          {
            validator: (r, val) => {
              const a = form.getFieldValue(`${rowIndex}-smartContentSell`)
              const b = form.getFieldValue(`${rowIndex}-smartContentSell2`)
              const c = form.getFieldValue(`${rowIndex}-smartContentSell3`)
              if (val) {
                if (restrictCNLength(val) < +getRules('minLength', item)) {
                  return Promise.reject(new Error(`不能少于${getRules('minLength', item)}个字`))
                } else if (restrictCNLength(val) > +getRules('maxLength', item) * 2) {
                  return Promise.reject(new Error(`不能多于${getRules('maxLength', item)}个字`))
                }
              }
              if ((a && b) || (b && c) || (a && c)) {
                return Promise.resolve()
              } else {
                if (!a && !b && !c) {
                  return Promise.resolve()
                }
                if (!val) {
                  return Promise.reject(new Error(`请输入${item.name}`))
                }
              }
              return Promise.resolve()
              // if (required) {
              //   if (!val) {
              //     return Promise.reject(new Error(`请输入${item.name}`))
              //   } else if (val.length < +getRules('minLength', item)) {
              //     return Promise.reject(new Error(`不能少于${getRules('minLength', item)}个字`))
              //   } else if (restrictCNLength(val) > +getRules('maxLength', item) * 2) {
              //     return Promise.reject(new Error(`不能多于${getRules('maxLength', item)}个字`))
              //   } else {
              //     return Promise.resolve()
              //   }
              // } else {
              //   if (val && val.length < +getRules('minLength', item)) {
              //     return Promise.reject(new Error(`不能少于${getRules('minLength', item)}个字`))
              //   }
              //   if (val && restrictCNLength(val) > +getRules('maxLength', item) * 2) {
              //     return Promise.reject(new Error(`不能多于${getRules('maxLength', item)}个字`))
              //   }
              //   return Promise.resolve()
              // }
            },
          },
        ]}
      >
        <Input
          disabled={
            !record.editorStatus ||
            (Status['审核失败'] === record.skuMaterialStatus &&
              record[name] &&
              record[name].status &&
              record[name].status !== 5)
          }
          autoComplete="off"
          placeholder={`${getRules('minLength', item)}~${getRules('maxLength', item)}个字`}
          onBlur={onApplyBtnBlur}
          onFocus={onApplyBtnFocus}
        />
      </Form.Item>
    )
  }
  return (
    <React.Fragment>
      {inputItem('smartContentSell', false)}
      {inputItem('smartContentSell2', false)}
      {inputItem('smartContentSell3', false)}
    </React.Fragment>
  )
}
const SmartContentSortTitle = ({ onApplyBtnFocus, onApplyBtnBlur, record, item, rowIndex }) => (
  <Form.Item
    name={`${rowIndex}-${item.id}`}
    className="custom-text-input"
    validateTrigger="onBlur"
    rules={[
      {
        validator: (r, val) => {
          const required = JSON.parse(getRules('required', item))
          if (required) {
            if (!val) {
              return Promise.reject(new Error(`请输入${item.name}`))
            } else if (restrictCNLength(val) < +getRules('minLength', item) * 2) {
              return Promise.reject(new Error(`不能少于${getRules('minLength', item)}个汉字`))
            } else if (restrictCNLength(val) > +getRules('maxLength', item) * 2) {
              return Promise.reject(new Error(`不能多于${getRules('maxLength', item)}个汉字`))
            } else {
              return Promise.resolve()
            }
          } else {
            if (val) {
              if (restrictCNLength(val) < +getRules('minLength', item) * 2) {
                return Promise.reject(new Error(`不能少于${getRules('minLength', item)}个汉字`))
              } else if (restrictCNLength(val) > +getRules('maxLength', item) * 2) {
                return Promise.reject(new Error(`不能多于${getRules('maxLength', item)}个汉字`))
              } else {
                return Promise.resolve()
              }
            }
            return Promise.resolve()
          }
        },
      },
    ]}
  >
    <Input
      disabled={
        !record.editorStatus ||
        (Status['审核失败'] === record.skuMaterialStatus &&
          record[item.id] &&
          record[item.id].status &&
          record[item.id].status !== 5)
      }
      autoComplete="off"
      placeholder={`${getRules('minLength', item)}~${getRules('maxLength', item)}个汉字`}
      onBlur={onApplyBtnBlur}
      onFocus={onApplyBtnFocus}
    />
  </Form.Item>
)

const SmartContentPicTransparent = ({
  onApplyBtnFocus,
  onApplyBtnBlur,
  record,
  item,
  rowIndex,
  uploadImgUrl,
  extraNode,
  flag,
}) => (
  <Form.Item
    name={`${rowIndex}-${item.id}`}
    className={flag ? '' : 'custom-uploader'}
    extra={flag ? extraNode : false}
    rules={[
      {
        required: JSON.parse(getRules('required', item)),
        message: `请上传图片`,
      },
    ]}
  >
    <UploadImg
      data={item}
      uploadImgUrl={uploadImgUrl}
      disabled={
        !record.editorStatus ||
        (Status['审核失败'] === record.skuMaterialStatus &&
          record[item.id] &&
          record[item.id].status &&
          record[item.id].status !== 5)
      }
    />
  </Form.Item>
)

const renderSpecialcode = ({ item, record, rowIndex, updateConfig, isProd }) => {
  const { form, updateData, save, showErpFeedBack, data } = useContext(TableContext)

  const codeMaps = {
    skuMaterialStatus: () => {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            className="custom-status-dot"
            style={{
              background: statusMaps[record.skuMaterialStatus] ? statusMaps[record.skuMaterialStatus].color : '',
            }}
          ></span>
          {Status[record.skuMaterialStatus]}
          {Status['机审通过'] === record.skuMaterialStatus && (
            <Tooltip
              placement="top"
              title="机审通过状态不等同于审核通过，后续可能被抽查驳回，请您保存前务必检查素材质量，按规则上传。"
            >
              <ExclamationCircleOutlined style={{ marginLeft: 2, color: 'rgba(0, 0, 0, 0.45)', fontSize: 14 }} />
            </Tooltip>
          )}
        </div>
      )
    },
    opt: () => {
      return <GetStatusBtn data={{ form, record, rowIndex, updateData, save, showErpFeedBack }} />
    },
    smartContentSell: () => (
      <BatchInput
        data={data}
        updateConfig={updateConfig}
        record={record}
        item={item}
        rowIndex={rowIndex}
        form={form}
        isPic={false}
        components={SmartContentSell}
        isProd={isProd}
      />
    ),
    smartContentSortTitle: () => (
      <BatchInput
        data={data}
        updateConfig={updateConfig}
        record={record}
        item={item}
        rowIndex={rowIndex}
        form={form}
        isPic={false}
        components={SmartContentSortTitle}
        isProd={isProd}
      />
    ),
    picUrl: () => (
      <BatchInput
        data={data}
        updateConfig={updateConfig}
        record={record}
        item={item}
        rowIndex={rowIndex}
        form={form}
        isPic={true}
        components={SmartContentPicTransparent}
        isProd={isProd}
      />
    ),
    smartPicWhite: () => (
      <BatchInput
        data={data}
        updateConfig={updateConfig}
        record={record}
        item={item}
        rowIndex={rowIndex}
        form={form}
        isPic={true}
        components={SmartContentPicTransparent}
        isProd={isProd}
      />
    ),
  }
  const func = codeMaps[item.code]
  return func ? func() : ''
}

const renderContainer = (item: Params, record, rowIndex: number, updateConfig: any, isProd: boolean): JSX.Element => {
  const { form, uploadImgUrl } = useContext(TableContext)
  // 初始化
  const { extraNode, flag } = getExtNode({ updateConfig, record, name: item.id, rowIndex, form, isProd })

  if (isCheckSpicialCode(item.code)) {
    return renderSpecialcode({ item, record, rowIndex, updateConfig, isProd })
  }

  const containerMaps = {
    '4': () => <SkuInfo record={record} />,
    '2': () => (
      <Form.Item
        name={`${rowIndex}-${item.id}`}
        className={flag ? '' : 'custom-uploader'}
        extra={flag ? extraNode : false}
        rules={[
          {
            required: JSON.parse(getRules('required', item)),
            message: `请上传图片`,
          },
        ]}
      >
        <UploadImg
          data={item}
          uploadImgUrl={uploadImgUrl}
          disabled={
            !record.editorStatus ||
            (Status['审核失败'] === record.skuMaterialStatus &&
              record[item.id] &&
              record[item.id].status &&
              record[item.id].status !== 5)
          }
        />
      </Form.Item>
    ),
    '1': () => (
      <Form.Item
        name={`${rowIndex}-${item.id}`}
        className="custom-text-input"
        validateTrigger="onBlur"
        rules={[
          {
            validator: (r, val) => {
              const required = JSON.parse(getRules('required', item))
              if (required) {
                if (!val) {
                  return Promise.reject(new Error(`请输入${item.name}`))
                } else if (restrictCNLength(val) < +getRules('minLength', item) * 2) {
                  return Promise.reject(new Error(`不能少于${getRules('minLength', item)}个汉字`))
                } else if (restrictCNLength(val) > +getRules('maxLength', item) * 2) {
                  return Promise.reject(new Error(`不能多于${getRules('maxLength', item)}个汉字`))
                } else {
                  return Promise.resolve()
                }
              } else {
                if (val) {
                  if (restrictCNLength(val) < +getRules('minLength', item) * 2) {
                    return Promise.reject(new Error(`不能少于${getRules('minLength', item)}个汉字`))
                  } else if (restrictCNLength(val) > +getRules('maxLength', item) * 2) {
                    return Promise.reject(new Error(`不能多于${getRules('maxLength', item)}个汉字`))
                  } else {
                    return Promise.resolve()
                  }
                }
                return Promise.resolve()
              }
            },
          },
        ]}
      >
        <Input
          disabled={
            !record.editorStatus ||
            (Status['审核失败'] === record.skuMaterialStatus &&
              record[item.id] &&
              record[item.id].status &&
              record[item.id].status !== 5)
          }
          autoComplete="off"
          placeholder={`${getRules('minLength', item)}~${getRules('maxLength', item)}个汉字`}
        />
      </Form.Item>
    ),
  }
  const fuc = containerMaps[item.dataType + '']
  return fuc ? fuc() : ''
}

export const getColumns = (item: Params, updateConfig, isProd: boolean) => {
  return {
    title: renderTitle(item),
    dataIndex: item.id,
    width: item.width ? item.width : 160,
    fixed: item.fixed ? item.fixed : null,
    render: item.render
      ? item.render
      : (t, record, rowIndex) => renderContainer(item, record, rowIndex, updateConfig, isProd),
  }
}
